<template>
  <div :class="[`${CLS_PRE}-timeline`]">
    <slot></slot>
  </div>
</template>

<script lang="ts">
import { defineComponent, provide } from 'vue';
import { useProvide } from './hook/useProvide/index';

import {
  COMP_NAME,
  CLS_PRE,
  EMITS_DEC,
  PROPS_DES,
  PROVIDE_KEY
} from './config';

export default defineComponent({
  name: COMP_NAME,
  emits: EMITS_DEC,
  props: PROPS_DES,
  setup(_, { expose }) {
    const { register, getIsLastCp, destroyItem } = useProvide();

    provide(PROVIDE_KEY, {
      register: register,
      getIsLastCp: getIsLastCp,
      destroyItem: destroyItem
    });

    // 在使用其它组件过程中，发现TS只能识别return中返回的数据，暂时做此处理。
    const exposeTemp = {
    };
    expose(exposeTemp);

    return {
      CLS_PRE,
      ...exposeTemp
    };
  }
});
</script>

<style lang="scss" src="./css/index.scss" scoped></style>
